// vuex getters
export function getLoginState (state) {
  return state.auth.loggedIn
}

export function getWinHeight (state) {
  return state.win.winHeight
}

export function getWinWidth (state) {
  return state.win.winWidth
}

export function getDirection (state) {
  return state.route.direction
}

export function getBackPath (state) {
  return state.route.pathStack[state.route.pathLevel].from.path
}
